export default __webpack_public_path__ + "static/media/VATCST-VAT.15ab8b7d.xlsx";